import { HttpContextToken } from '@angular/common/http';
import { CodeError, ErrorContentName } from './enums';
import { fe_products } from 'src/environments';

export const RUT_PJ_THRESHOLD = 50000000;
export const MAX_RUT_DIGITS = 9;
export const MAX_PHONE_DIGITS = 8;
export const MAX_OTP_DIGITS = 6;
export const MAX_LENGTH_RUT = MAX_RUT_DIGITS + 3;
export const ALLOWED_KEYS = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
export const SKIP_LOADER = new HttpContextToken<boolean>(() => false);

export const SIMULATOR_BY_TYPE = {
	ccfogape: fe_products.simuladorFogape,
	compracartera: fe_products.simuladorCompraCartera,
	factoring: fe_products.simuladorFactoring,
} as const;

export const HEADER_KEYS = {
	trackingId: 'Tracking-id',
	referenceOperation: 'Reference-Operation',
	uuid: 'Uuid',
	referenceService: 'Reference-Service',
} as const;

export const Patterns = {
	oneDigit: /^\d$/,
	onlyDigits: /\D/g,
	phone: /^\+569\d{8}$/,
	email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
	externalUrl: /^https?:\/\//,
};

export const QUERY_PARAMS = {
	PRODUCT: 'producto',
} as const;

export const Links = {
	legal: {
		privacyPolicyBCI: 'https://www.bci.cl/corporativo/politicas-y-normas/politicas-de-privacidad',
	},
	institutional: {
		bciLogin: 'https://www.bci.cl/corporativo/banco-en-linea/pyme',
		bciPyme: 'https://www.bci.cl/pyme',
		bciPymeFogape: 'https://www.bci.cl/pyme/financiamiento-fogape',
		cmf: 'https://www.cmfchile.cl',
	},
};

export const RecaptchaActions = {
	checkPreapprovalValidity: 'checkPreapprovalValidity',
};

export const Steps = [
	{ name: 'Datos empresa' },
	{ name: 'Verificación de datos' },
	{ name: 'Simulación' },
];

export const ErrorToReturnContentName: Record<CodeError, ErrorContentName> = {
	[CodeError.OTP_VALIDATE_LIMIT]: ErrorContentName.OTP_LIMIT,
	[CodeError.OTP_GENERATION_LIMIT]: ErrorContentName.GENERIC_ERROR,
	[CodeError.INELIGIBLE_CUSTOMER]: ErrorContentName.INELIGIBLE_CUSTOMER,
};
